import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { CalendarService } from '../../services/calendar/calendar.service';
import { CourseCategoryActions, CourseCategoryApiActions } from './courseCategory.actions';

@Injectable()
export class CourseCategoryEffects {
    constructor(
        private actions$: Actions,
        private calendarService: CalendarService
    ) {}

    loadCourseCategories$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CourseCategoryApiActions.loadCourseCategories),
            switchMap(() =>
                this.calendarService.loadCourseCategories().pipe(
                    map((courseCategories) => CourseCategoryActions.loadCourseCategoriesSuccess({ courseCategories })),
                    catchError((error) => of(CourseCategoryActions.loadCourseCategoriesFailure({ error })))
                )
            )
        );
    });

    createCourseCategory$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CourseCategoryApiActions.createCourseCategory),
            switchMap(({ courseCategory }) =>
                this.calendarService.createCourseCategory(courseCategory).pipe(
                    map((courseCategory) => CourseCategoryActions.createCourseCategorySuccess({ courseCategory })),
                    catchError((error) => of(CourseCategoryActions.createCourseCategoryFailure({ error })))
                )
            )
        );
    });
}
